import { LazyModule, createLazyComponent } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GroupFilesHub" */ './lazyIndex');
});
export var LazyGroupFilesHub = createLazyComponent(lazyModule, function (m) { return m.FilesHub; });
export var LazyGroupFilesHubCommandBar = createLazyComponent(lazyModule, function (m) { return m.FilesHubCommandBar; });
export var LazyGroupFilesHubSxSLayerView = createLazyComponent(lazyModule, function (m) { return m.GroupFilesHubSxSLayerView; });
//# sourceMappingURL=index.js.map